import TrashBascketIcon from './component'

export default TrashBascketIcon
